import { db } from '../firebaseInit'
// import _ from 'lodash'

export default {
  state: {
    contactList: [],
    builderList: [],
    contactSearchList: []
  },
  mutations: {
    editBuilder (state, payload) {
      state.builderList[payload.index] = { ...state.builderList[payload.index], ...payload.newState }
    },
    deleteBuilder (state, payload) {
      state.builderList.splice(payload.itemIndex, 1)
    },
    getContactList (state, payload) {
      state.contactList = payload
    },
    getBuildersList (state, payload) {
      state.builderList = payload
    },
    getSearchContacts (state, payload) {
      state.contactSearchList = payload
    },
    createContact (state, payload) {
      state.contactList.push(payload)
      if (payload.type === 'Builder') {
        state.builderList.push({ id: payload.id, company_name: payload.company_name, city: payload.city, phone: payload.phone_1 })
      }
    },
    editContact (state, payload) {
      state.contactList[payload.contactListIndex] = { ...state.contactList[payload.contactListIndex], ...payload.newState }
      state.contactSearchList[payload.searchListIndex] = { ...state.contactSearchList[payload.searchListIndex], ...payload.newState }
    },
    deleteContact (state, payload) {
      state.contactList.splice(payload.itemIndex, 1)
      state.contactSearchList.splice(payload.searchListIndex, 1)
    }
  },
  actions: {
    editBuilderContact ({ commit, getters, dispatch, state }, payload) {
      // {array: this.builderContacts, from: from, to: to, id: this.builder.id}
      db.collection('contacts').doc(payload.id).update({ builder_contacts: payload.array }).then(() => {
        const logData = { timestamp: new Date(), collection: 'builder contacts', type: 'edited', user_id: getters.user.id, record_id: payload.id, message: getters.user.first_name + ' edited the builder contact (' + payload.builderContact.first_name + ' ' + payload.builderContact.last_name + ') for ' + payload.companyName, icon: 'home' }
        dispatch('commitLog', logData)
      })
    },
    deleteBuilderContact ({ commit, getters, dispatch, state }, payload) {
      db.collection('contacts').doc(payload.id).update({ builder_contacts: payload.contactArray }).then(() => {
        const logData = { timestamp: new Date(), collection: 'builder contacts', type: 'deleted', user_id: getters.user.id, record_id: payload.id, message: getters.user.first_name + ' deleted the builder contact (' + payload.deletedContact.first_name + ' ' + payload.deletedContact.last_name + ') from ' + payload.companyName, icon: 'home' }
        dispatch('commitLog', logData)
      })
    },
    addBuilderContact ({ commit, getters, dispatch, state }, payload) {
      db.collection('contacts').doc(payload.id).update({ builder_contacts: payload.arrayPayload }).then(() => {
        const logData = { timestamp: new Date(), collection: 'builder contacts', type: 'created', user_id: getters.user.id, record_id: payload.id, message: getters.user.first_name + ' added the builder contact (' + payload.newContact.first_name + ' ' + payload.newContact.last_name + ') for ' + payload.company_name, icon: 'home' }
        dispatch('commitLog', logData)
      })
    },
    editBuilder ({ commit, getters, dispatch, state }, payload) {
      const index = state.builderList.findIndex(i => i.id === payload.id)
      db.collection('contacts').doc(payload.id).update(payload.newState).then(() => {
        commit('editBuilder', { data: payload.newState, index: index })
        const logData = { timestamp: new Date(), collection: 'builders', type: 'deleted', user_id: getters.user.id, changedFrom: payload.previousState, changedTo: payload.newState, record_id: payload.id, message: getters.user.first_name + ' edited a builder contact for ' + payload.company_name, icon: 'home' }
        dispatch('commitLog', logData)
      })
    },
    // Get Contact List
    getContactList ({ commit, state, getters, dispatch }, payload) {
      let assignedContacts = []
      db.collection('projects').get().then(projects => {
        projects.forEach(project => {
          if (project.data().assigned_to.includes(getters.user.id)) {
            const allProjects = Object.keys(project.data().contacts)
            allProjects.forEach(allProject => {
              assignedContacts.push(allProject)
            })
          }
        })
      })
        .then(() => {
          assignedContacts = [...new Set(assignedContacts)]
          state.contactList = []
          commit('setLoading', true)
          let query = db.collection('contacts').where('deleted', '==', false)
          // Adjust Filters
          if (payload.indexOf('Active') !== -1) {
            if (payload.indexOf('Inactive') === -1) {
              query = query.where('active', '==', true)
            }
          }
          if (payload.indexOf('Inactive') !== -1) {
            if (payload.indexOf('Active') === -1) {
              query = query.where('active', '==', false)
            }
          }
          if (payload.indexOf('Customers') !== -1) {
            if (payload.indexOf('Leads') === -1) {
              query = query.where('type', '==', 'Customer')
            }
          }
          if (payload.indexOf('Leads') !== -1) {
            if (payload.indexOf('Customers') === -1) {
              query = query.where('type', '==', 'Lead')
            }
          }
          // Get Contacts Based On Filter Criteria
          query.get()
            .then(querySnapshot => {
              let contactList = []
              querySnapshot.forEach(doc => {
                const assigned = assignedContacts.includes(doc.id)
                if (getters.user.permissions.contacts.view.all || (getters.user.permissions.contacts.view.assigned && assigned)) {
                  const contacts = {
                    id: doc.id,
                    type: doc.data().type,
                    company_name: doc.data().company_name,
                    first_name: doc.data().first_name,
                    last_name: doc.data().last_name,
                    email: doc.data().email,
                    phone_1: doc.data().phone_1,
                    secondaryContact_first_name: doc.data().secondaryContact_first_name,
                    secondaryContact_last_name: doc.data().secondaryContact_last_name,
                    secondaryContact_email: doc.data().secondaryContact_email,
                    secondaryContact_phone_1: doc.data().secondaryContact_phone_1,
                    created_by: doc.data().created_by,
                    assigned_to: doc.data().assigned_to,
                    active: doc.data().active
                  }
                  contactList.push(contacts)
                }
              })
              commit('getContactList', contactList)
              commit('setLoading', false)
            })
            .catch(error => {
              console.log(error)
              this.$store.dispatch('setError', { timestamp: new Date(), collection: 'contacts', type: 'get', user_id: getters.user.id, route: '/contacts', error: error.message })
              commit('setLoading', false)
            })
        })
    },
    getSearchContacts ({ commit, state, getters, dispatch }, payload) {
      // Get Assigned Contacts By Getting Assigned Projects With Contact Ids
      let assignedContacts = []
      db.collection('projects').get().then(projects => {
        projects.forEach(project => {
          if (project.data().assigned_to.includes(getters.user.id)) {
            const allProjects = Object.keys(project.data().contacts)
            allProjects.forEach(allProject => {
              assignedContacts.push(allProject)
            })
          }
        })
      })
        .then(() => {
          assignedContacts = [...new Set(assignedContacts)]
          db.collection('contacts').where('deleted', '==', false).get()
            .then(querySnapshot => {
              let allContactList = []
              querySnapshot.forEach(doc => {
                const assigned = assignedContacts.includes(doc.id)
                if (getters.user.permissions.contacts.view.all || (getters.user.permissions.contacts.view.assigned && assigned)) {
                  const contacts = {
                    id: doc.id,
                    type: doc.data().type,
                    name: doc.data().first_name + ' ' + doc.data().last_name,
                    created_date: doc.data().created_date,
                    assigned: assigned,
                    source: 'Not Specified',
                    address: doc.data().address,
                    city: doc.data().city,
                    phone: doc.data().phone_1
                  }
                  if (doc.data().secondaryContact_first_name) {
                    contacts.name = doc.data().first_name + ' ' + doc.data().last_name + ' and ' + doc.data().secondaryContact_first_name + ' ' + doc.data().secondaryContact_last_name
                  }
                  if (doc.data().opportunities && doc.data().opportunities.length > 0) {
                    doc.data().opportunities.forEach(opp => {
                      allContactList.push({...contacts, sales_rep: opp.sales_rep, contract_amount: opp.contract_amount ? opp.contract_amount : 0, projectName: opp.name, source: opp.source ? opp.source : 'Not Specified', created_date: opp.created_date})
                    })
                  }
                  if (doc.data().opportunities && doc.data().opportunities.length < 1) {
                    allContactList.push({...contacts, sales_rep: null, contract_amount: null, projectName: null, source: doc.data().source ? doc.data().source : null, created_date: doc.data().created_date})
                  }
                }
              })
              let searchContacts = allContactList.filter(contacts => {
                return contacts.type !== 'Builder'
              })
              dispatch('executeSearchContacts', { userId: payload, contacts: searchContacts })
            })
        })
    },
    executeSearchContacts ({ commit, state, getters, dispatch }, payload) {
      // Permissions
      if (getters.user) {
        // const userId = getters.user.id
        let searchContacts = payload.contacts
        // if (getters.user.role !== 'Admin') {
        //   // Get Created and Sales Rep Contacts
        //   searchContacts = searchContacts.filter(f => f.created_by === userId || f.sales_rep === userId)
        //   console.log('searchContacts', searchContacts)
        // }
        commit('getSearchContacts', searchContacts)
      } else {
        setTimeout(() => {
          dispatch('executeSearchContacts', payload)
        }, 500)
      }
    },
    getBuilders ({ commit, state }) {
      let buildersList = []
      db.collection('contacts').where('type', '==', 'Builder').where('deleted', '==', false).get().then(query => {
        query.forEach(item => {
          buildersList.push({ ...item.data(), id: item.id })
        })
      }).then(() => {
        commit('getBuildersList', buildersList)
      })
    },
    createContact ({ commit, state, getters, dispatch }, payload) {
      const { id, ...withoutFirst } = payload
      let opps = []
      if (payload.isFromBuilder) {
        opps = payload.opportunities
      } else {
        if (payload.opportunities) {
          payload.opportunities.created_date = new Date()
          opps = [payload.opportunities]
        }
      }
      const newContact = { ...withoutFirst, created_by: getters.user.id, created_date: new Date(), deleted: false, active: true, opportunities: opps }
      db.collection('contacts').doc(payload.id).set(newContact).then(doc => {
        const logIcon = payload.type === 'Lead' ? 'person_outline' : payload.type === 'Builder' ? 'home' : 'person'
        const logData = { timestamp: new Date(), collection: 'contacts', type: 'created', user_id: getters.user.id, record_id: payload.id, message: getters.user.first_name + ' created a new ' + payload.type + ': ' + payload.first_name + ' ' + payload.last_name, icon: logIcon }
        dispatch('commitLog', logData)
        commit('createContact', payload)
      })
        .catch(error => {
          console.log(error)
          this.$store.dispatch('setError', { timestamp: new Date(), collection: 'contacts', type: 'create', user_id: getters.user.id, route: '/contacts', error: error.message })
        })
    },
    editContact ({ commit, state, getters, dispatch }, payload) {
      db.collection('contacts').doc(payload.id).update(payload.newState)
      const logIcon = payload.type === 'Lead' ? 'person_outline' : payload.type === 'Builder' ? 'home' : 'person'
      const logData = { timestamp: new Date(), collection: 'contacts', type: 'edit', user_id: getters.user.id, record_id: payload.id, changed_from: payload.previousState, changed_to: payload.newState, message: getters.user.first_name + ' made changes to the ' + payload.type + ': ' + payload.first_name + ' ' + payload.last_name, icon: logIcon }
      const contactListIndex = state.contactList.findIndex(x => x.id === payload.id)
      const searchListIndex = state.contactSearchList.findIndex(x => x.id === payload.id)
      const newPayload = { ...payload, contactListIndex: contactListIndex, searchListIndex: searchListIndex }
      commit('editContact', newPayload)
      dispatch('commitLog', logData)
    },
    deleteContact ({ commit, state, getters, dispatch }, payload) {
      db.collection('contacts').doc(payload.id).update({
        deleted: true,
        active: false
      })
      const contactListIndex = state.contactList.findIndex(x => x.id === payload.id)
      const searchListIndex = state.contactSearchList.findIndex(x => x.id === payload.id)
      const newPayload = { itemIndex: contactListIndex, searchListIndex: searchListIndex }
      const logIcon = payload.type === 'Lead' ? 'person_outline' : payload.type === 'Builder' ? 'home' : 'person'
      const logData = { timestamp: new Date(), collection: 'contacts', type: 'deleted', user_id: getters.user.id, record_id: payload.id, message: getters.user.first_name + ' deleted the ' + payload.type + ': ' + payload.first_name + ' ' + payload.last_name, icon: logIcon }
      dispatch('commitLog', logData)
      commit('deleteContact', newPayload)
    },
    deleteBuilder ({ commit, state, getters, dispatch }, payload) {
      db.collection('contacts').doc(payload.id).update({
        deleted: true,
        active: false
      })
      const builderIndex = state.builderList.findIndex(x => x.id === payload.id)
      const newPayload = { itemIndex: builderIndex }
      const logData = { timestamp: new Date(), collection: 'builders', type: 'deleted', user_id: getters.user.id, record_id: payload.id, message: getters.user.first_name + ' deleted the builder' + payload.company_name, icon: 'home' }
      dispatch('commitLog', logData)
      commit('deleteBuilder', newPayload)
    }
  },
  getters: {
    contactList (state) {
      return state.contactList
    },
    builderList (state) {
      return state.builderList
    },
    getContactSearchList (state) {
      return state.contactSearchList
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/contacts.js